import React, { FC } from 'react'
import {
  Affilates,
  Contact,
  CTA,
  Guests,
  HeroWrapper,
  Shows,
  Slider,
  SocialPanel,
  Benefits,
} from '../components/Home'


const Home: FC = () => {
  return (
    <>
      <HeroWrapper />
      <Slider />
      <Benefits />
      <Affilates />
      <Guests />
      <Shows />
      <CTA /> 
      <SocialPanel />
      <Contact />
    </>
  )
}
export default Home
